import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Footer from "../../../Include/Footer";
import Header from "../../../Include/Header";
import Sidebar from "../../../Include/Sidebar";
import Breadcrumb from "../../../../../Components/Breadcrumb/Breadcrumb";
import PurReturnFields from "./components/PurReturnFields";
import PurReturnItems from "./components/PurReturnItems";
import moment from "moment";
import { getProject } from "../../../../../Store/Store/Project/Project";
import { getParty } from "../../../../../Store/Store/Party/Party";
import { getGenMaster } from "../../../../../Store/Store/GenralMaster/GenMaster";
import { getItem } from "../../../../../Store/Store/Item/Item";
import { getTransport } from "../../../../../Store/Store/StoreMaster/Transport/Transport";
import { V_URL } from "../../../../../BaseUrl";
import toast from "react-hot-toast";
import axios from "axios";
import { getViewReturnItems } from "../../../../../Store/prosafe/proTransaction/PurReturn/getViewReturnItems";

const ManagePurReturn = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { state: data } = useLocation();
  const [disable, setDisable] = useState(false);
  const [error, setError] = useState({});
  const [form, setForm] = useState({
    trans_date: moment(Date.now()).format("YYYY-MM-DD"),
    project_id: "",
    manual_pro_no: "",
    party_id: "",
    master_id: "",
    receive_date: moment(Date.now()).format("YYYY-MM-DD"),
    bill_no: "",
    transport_id: "",
    transport_date: "",
    transport_charges: "",
    lr_no: "",
    lr_date: "",
    challan_no: "",
    pdf: "",
    vehical_no: "",
    driver_name: "",
  });
  const [itemsArr, setItemsArr] = useState([]);

  useEffect(() => {
    dispatch(getGenMaster({ tag_id: 12 }));
    dispatch(getProject());
    dispatch(getParty({ is_main: true }));
    dispatch(getItem({ is_main: true }));
    dispatch(getTransport());
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
    if (error[name]) {
      setError((prev) => {
        const newError = { ...prev };
        delete newError[name];
        return newError;
      });
    }
  };

  const handlePdf = (e) => {
    const file = e?.target?.files?.[0];
    if (!file) return;
    const fileType = file.type;
    const allowedTypes = {
      pdf: ["application/pdf"],
      image: ["image/png", "image/jpeg", "image/jpg", "image/webp"],
    };
    const fileCategory = Object.keys(allowedTypes).find((type) =>
      allowedTypes[type].includes(fileType)
    );
    if (!fileCategory) {
      toast.error("Invalid file type. Only images and PDFs are allowed.");
      return;
    }
    const uploadUrl = `${V_URL}/upload-image`;
    const formData = new FormData();
    formData.append("image", file);
    axios
      .post(uploadUrl, formData)
      .then((res) => {
        if (res.data.success) {
          const uploaded = res.data.data?.[fileCategory];
          setForm((prev) => ({ ...prev, pdf: uploaded }));
        }
      })
      .catch((err) => {
        console.error(err);
        toast.error(err.response?.data?.message || "Upload failed");
      });
  };

  const itemData = useSelector(
    (state) => state?.getViewReturnItems?.user?.data
  );

  useEffect(() => {
    if (data?._id) {
      dispatch(getViewReturnItems({ formData: { id: data?._id } }));
      setForm({
        trans_date: moment(data?.trans_date).format("YYYY-MM-DD"),
        project_id: data?.project_data?._id,
        manual_pro_no: data?.manual_pro_no,
        party_id: data?.party_data?._id,
        master_id: data?.return_by?._id,
        receive_date: moment(data?.receive_date).format("YYYY-MM-DD"),
        bill_no: data?.bill_no,
        transport_id: data?.transport_data?._id,
        transport_date: moment(data?.transport_date).format("YYYY-MM-DD"),
        transport_charges: data?.transport_charges,
        lr_no: data?.lr_no,
        lr_date: moment(data?.lr_date).format("YYYY-MM-DD"),
        challan_no: data?.challan_no,
        pdf: data?.pdf,
        vehical_no: data?.vehical_no,
        driver_name: data?.driver_name,
      });
    } else {
      handleReset();
    }
  }, [data]);

  useEffect(() => {
    if (data?._id) {
      if (itemData?.items_details?.length > 0) {
        setItemsArr(itemData.items_details);
      } else {
        setItemsArr([]);
      }
    } else {
      setItemsArr([]);
    }
  }, [itemData, data]);

  const validateItems = () => {
    if (!itemsArr || itemsArr.length === 0) {
      toast.error("At least one item is required");
      return false;
    }
    return true;
  };

  const validateForm = () => {
    const newErrors = {};
    let isValid = true;
    const checkRequired = (field, message) => {
      if (!form[field]) {
        newErrors[field] = message;
        isValid = false;
      }
    };
    if (!form.trans_date) {
      newErrors.trans_date = "Date is required";
      isValid = false;
    } else {
      const selectedDate = new Date(form.trans_date);
      const currentDate = new Date();
      if (selectedDate > currentDate) {
        newErrors.trans_date = "Date cannot be in the future";
        isValid = false;
      }
    }

    if (form.transport_charges < 0) {
      newErrors.transport_charges = "Please Enter valid Value";
      isValid = false;
    }

    checkRequired("project_id", "Project is required");
    checkRequired("party_id", "Party is required");
    checkRequired("receive_date", "Receiving Date is required");
    checkRequired("master_id", "Received By is required");
    if (!form.bill_no && !form.challan_no) {
      newErrors.bill_no = "Either Bill No. or Challan No. is required";
      newErrors.challan_no = "Either Bill No. or Challan No. is required";
      isValid = false;
    }
    checkRequired("transport_id", "Transport is required");
    checkRequired("pdf", "PDF/Image file is required");
    setError(newErrors);
    return isValid;
  };

  const handleSubmit = () => {
    if (!validateForm()) {
      return;
    }
    if (!validateItems()) {
      return;
    }
    setDisable(true);
    const myurl = `${V_URL}/prosafe/pro-add-one-pur`;
    const formData = new URLSearchParams();
    formData.append("tag_number", 12);
    formData.append("firm_id", localStorage.getItem("PAY_USER_FIRM_ID"));
    formData.append("year_id", localStorage.getItem("PAY_USER_YEAR_ID"));
    formData.append("trans_date", form.trans_date);
    formData.append("project_id", form.project_id);
    formData.append("manual_pro_no", form.manual_pro_no);
    formData.append("party_id", form.party_id);
    formData.append("master_id", form.master_id);
    formData.append("receive_date", form.receive_date);
    formData.append("bill_no", form.bill_no);
    formData.append("transport_id", form.transport_id);
    formData.append("transport_date", form.transport_date);
    formData.append("transport_charges", form.transport_charges);
    formData.append("lr_no", form.lr_no);
    formData.append("lr_date", form.lr_date);
    formData.append("challan_no", form.challan_no);
    formData.append("pdf", form.pdf);
    formData.append("vehical_no", form.vehical_no);
    formData.append("driver_name", form.driver_name);
    formData.append("items_details", JSON.stringify(itemsArr));
    axios({
      method: "post",
      url: myurl,
      data: formData,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: "Barrer " + localStorage.getItem("PAY_USER_TOKEN"),
      },
    })
      .then((response) => {
        if (response.data.success === true) {
          toast.success(response?.data?.message);
          navigate("/main-store/user/purchase-return-management");
        } else {
          toast.error(response?.data?.message);
        }
      })
      .catch((error) => {
        toast.error(error?.response?.data?.message || "Something went wrong");
      })
      .finally(() => {
        setDisable(false);
      });
  };

  const handleUpdate = (e) => {
    if (!validateForm()) {
      return;
    }

    if (!validateItems()) {
      return;
    }

    setDisable(true);
    const myurl = `${V_URL}/prosafe/pro-update-pur`;

    // const formData = new URLSearchParams();
    // formData.append("id", data?._id);
    // formData.append("trans_date", form.trans_date);
    // formData.append("bill_no", form.bill_no);
    // formData.append("challan_no", form.challan_no);
    // formData.append("master_id", form.master_id);
    // formData.append("receive_date", form.receive_date);
    // formData.append("transport_id", form.transport_id);
    // formData.append("transport_date", form.transport_date);
    // formData.append("vehical_no", form.vehical_no);
    // formData.append("transport_charges", form.transport_charges);
    // formData.append("lr_no", form.lr_no);
    // formData.append("lr_date", form.lr_date);
    // formData.append("driver_name", form.driver_name);
    // formData.append("pdf", form.pdf);

    const payload = {
      id: data?._id,
      trans_date:
        form?.trans_date && moment(form.trans_date).isValid()
          ? moment(form.trans_date).format("YYYY-MM-DD")
          : null,
      bill_no: form.bill_no,
      manual_pro_no: form.manual_pro_no,
      challan_no: form.challan_no,
      master_id: form.master_id,
      receive_date:
        form?.receive_date && moment(form.receive_date).isValid()
          ? moment(form.receive_date).format("YYYY-MM-DD")
          : null,
      transport_id: form.transport_id,
      transport_date:
        form?.transport_date && moment(form.transport_date).isValid()
          ? moment(form.transport_date).format("YYYY-MM-DD")
          : null,
      vehical_no: form.vehical_no,
      transport_charges: form.transport_charges ? form.transport_charges : null,
      lr_no: form.lr_no,
      lr_date:
        form?.lr_date && moment(form.lr_date).isValid()
          ? moment(form.lr_date).format("YYYY-MM-DD")
          : null,
      driver_name: form.driver_name,
      pdf: form.pdf,
    };

    axios({
      method: "put",
      url: myurl,
      data: payload,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: "Barrer " + localStorage.getItem("PAY_USER_TOKEN"),
      },
    })
      .then((response) => {
        if (response.data.success === true) {
          toast.success(response?.data?.message);
          navigate("/main-store/user/purchase-return-management");
        } else {
          toast.error(response?.data?.message);
        }
      })
      .catch((error) => {
        toast.error(error?.response?.data?.message || "Something went wrong");
      })
      .finally(() => {
        setDisable(false);
      });
  };

  const handleReset = () => {
    setForm({
      trans_date: moment(Date.now()).format("YYYY-MM-DD"),
      project_id: "",
      manual_pro_no: "",
      party_id: "",
      master_id: "",
      receive_date: moment(Date.now()).format("YYYY-MM-DD"),
      bill_no: "",
      transport_id: "",
      transport_date: "",
      transport_charges: "",
      lr_no: "",
      lr_date: "",
      challan_no: "",
      pdf: "",
      vehical_no: "",
      driver_name: "",
    });
    setItemsArr([]);
    setError({});
  };

  const breadcrumbItems = [
    { label: "Dashboard", link: "/main-store/user/dashboard" },
    {
      label: "Purchase Return",
      link: "/main-store/user/purchase-return-management",
    },
    { label: data?._id ? "Edit" : "Add" + " Purchase Return", active: true },
  ];

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const handleOpen = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <div className={`main-wrapper ${isSidebarOpen ? "slide-nav" : ""}`}>
      <Header handleOpen={handleOpen} />
      <Sidebar />

      <div className="page-wrapper">
        <div className="content">
          <Breadcrumb items={breadcrumbItems} />

          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-body">
                  <form>
                    <div className="col-12">
                      <div className="form-heading">
                        <h4>
                          {data?._id ? "Edit" : "Add"} Purchase Return Details
                        </h4>
                      </div>
                    </div>

                    <PurReturnFields
                      handleChange={handleChange}
                      handlePdf={handlePdf}
                      form={form}
                      error={error}
                      data={data}
                    />
                  </form>
                </div>
              </div>
            </div>
          </div>

          <PurReturnItems
            itemsArr={itemsArr}
            setItemsArr={setItemsArr}
            data={data}
            form={form}
            setForm={setForm}
          />

          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-body">
                  <div className="col-12 text-end">
                    <div className="doctor-submit text-end">
                      <button
                        type="button"
                        className="btn btn-primary submit-form me-2"
                        onClick={data?._id ? handleUpdate : handleSubmit}
                        disabled={disable && !data?._id}
                      >
                        {disable
                          ? "Processing..."
                          : data?._id
                          ? "Update"
                          : "Submit"}
                      </button>
                      <button
                        type="button"
                        className="btn btn-primary cancel-form"
                        onClick={handleReset}
                      >
                        Reset
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default ManagePurReturn;
